import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Icon from '@mui/material/Icon';
import SoftBox from 'components/SoftBox';
import { item, itemContent, itemArrow } from 'prefabsComponents/Sidenav/styles/sidenavItem';
import { useSoftUIController } from 'context';

function SidenavItem({ name, active, nested, children, open, ...rest }) {
  const [controller] = useSoftUIController();
  const { miniSidenav } = controller; // Usamos el valor real

  return (
    <>
      <ListItem {...rest} component="li" sx={item}>
        <SoftBox
          sx={theme =>
            itemContent(theme, {
              active,
              miniSidenav, // Se usa para ocultar el texto cuando está colapsado
              name,
              nested,
            })
          }
        >
          <ListItemText primary={name} />
          {children && (
            <Icon
              component="i"
              sx={theme =>
                itemArrow(theme, { open, miniSidenav })
              }
            >
              expand_less
            </Icon>
          )}
        </SoftBox>
      </ListItem>
      {children && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {children}
        </Collapse>
      )}
    </>
  );
}

SidenavItem.defaultProps = {
  active: false,
  nested: false,
  children: false,
  open: false,
};

SidenavItem.propTypes = {
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
  nested: PropTypes.bool,
  children: PropTypes.node,
  open: PropTypes.bool,
};

export default SidenavItem;
